import { ModalContext } from "@/pages/_app";
// import Link from "next/link";
import { useContext } from "react";

function WishListReminder({ t, setloginReminder }) {
  const Context = useContext(ModalContext);
  return (
    <div className="fixed top-0 left-0 z-50 w-screen h-screen bg-lightblack">
      <div className="flex flex-col items-center justify-between absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-5 w-[570px] max-[570px]:w-[95%] max-[570px]:mx-auto max-[570px]:px-3 rounded-md">
        <h5 className="text-[22px] text-[#555] text-center">
          {t("GoToLoginText")}
        </h5>

        {/* <Link
          href={`/auth/login`}
          className="mt-[2rem] text-center flex justify-center items-center py-2 px-3 bg-blue campaign:bg-campaignAccent hover:bg-lightred disabled:bg-lightred duration-500 transition-colors text-white rounded-full w-full"
        >
          {t("Login")}
        </Link>*/}

        <button
          onClick={() => {
            setloginReminder(false);
            Context?.dispatch({ type: "authModal" });
          }}
          className="mt-[2rem] text-center flex justify-center items-center py-2 px-3 bg-blue campaign:bg-campaignAccent hover:bg-lightred disabled:bg-lightred duration-500 transition-colors text-white rounded-full w-full"
        >
          {t("Login")}
        </button>

        <button
          className="text-[14px] mt-[.5rem] text-blue duration-500 hover:text-lightblue"
          onClick={() => setloginReminder(false)}
        >
          {t("Skip")}
        </button>
      </div>
    </div>
  );
}

export default WishListReminder;
